import React from 'react';
import { useForm, FormProvider, SubmitHandler } from "react-hook-form";
import { AddPaymentType, BookingType } from '../../Components/Types';
import Button from '../../Components/Button';
import NumberField from '../../Components/FormGroup/NumberField';
import { minPaymountAmount, toastConfig } from '../../Components/Constants';
import { useMsal } from '@azure/msal-react';
import { toast } from 'react-toastify';
import { PaymentAPI } from 'API/PaymentAPI';

type AddPaymentFormProps = {
    booking: BookingType;
}

function AddPaymentForm({ booking }: AddPaymentFormProps) {
    const methods = useForm<AddPaymentType>();
    const { instance } = useMsal();
    const onSubmit: SubmitHandler<AddPaymentType> = async data => {
        const maxPaymentVal = booking.total_cost - booking.total_payment;
        const paymentVal = parseInt(data.payment_value.replace(/\D/g, '').replace('.', ''));
        if (paymentVal >= minPaymountAmount && paymentVal <= maxPaymentVal) {
            const processPayment = async () => {
                const response = await PaymentAPI.process(instance, booking.booking_id, paymentVal, false);
                window.location.replace(response.message);
            }
            processPayment();
        }
        else {
            if (paymentVal < minPaymountAmount) {
                const message = "Pay amount is too low";
                toast.error(message, { ...toastConfig, toastId: message + "-toast" });
            }
            else {
                const message = "Pay amount is too high";
                toast.error(message, { ...toastConfig, toastId: message + "-toast" });
            }
        }
    }
    return (
        <>
            <FormProvider {...methods}>
                <form onSubmit={methods.handleSubmit(onSubmit)} style={{display:"flex", alignItems:"center"}}>
                    <NumberField currency={true} name='payment_value' required={true} />
                    <Button type="submit" text="Add payment" colour="dark" css={{ float: "left", marginTop: "0.5em" }} />
                </form>
            </FormProvider>
        </>
    );
}
export default AddPaymentForm;
